module.exports = __webpack_public_path__ + "static/media/ico_setting.82f7a2ec.svg";